import React from 'react';
import PageSyle from '../style';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page18({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen titles={['Day 4', 'Shoulders and Triceps']} BGImage={CategoryScreenBG} />
			<RoundScreen
				title='Exercise 01 Shoulder Exercises'
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'Shoulder Barbell Press',
						},
						{
							header: '# of sets',
							value: '1',
						},
						{
							header: 'REPS / Weight',
							value: '10 Light',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Warm Up, “Blood Flow” Targeting All 3 Heads',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Shoulder Barbell Press',
						},
						{
							header: '# of sets',
							value: '2 - 3',
						},
						{
							header: 'REPS / Weight',
							value: '8 - 10 Mild - Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Working Set, Strict Form',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Shoulder Barbell Press',
						},
						{
							header: '# of sets',
							value: '4',
						},
						{
							header: 'REPS / Weight',
							value: 'Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full On Set Till Failure',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
